/**
 * API client error class
 *
 * Structured error type for API request failures.
 */

/**
 * Custom error class for API client failures.
 * Extends the native Error class with HTTP status, error code, and additional context.
 *
 * @example
 * ```typescript
 * throw new ApiClientError('Resource not found', {
 *   status: 404,
 *   code: 'NOT_FOUND',
 *   details: { resourceId: '123' }
 * });
 * ```
 */
export class ApiClientError extends Error {
  status: number;
  code?: string;
  details?: unknown;
  data?: unknown;

  constructor(
    message: string,
    opts: { status: number; code?: string; details?: unknown; data?: unknown }
  ) {
    super(message);
    this.name = 'ApiClientError';
    this.status = opts.status;
    if (opts.code) {
      this.code = opts.code;
    }
    if (opts.details !== undefined) {
      this.details = opts.details;
    }
    if (opts.data !== undefined) {
      this.data = opts.data;
    }
  }
}
